/*
 * NANOVIT — Abas do carrinho (Calcular frete / Desconto / Observação).
 * Precisa ser carregado no documento de topo (layout), NÃO inline dentro do
 * cart-summary: o conteúdo do drawer é injetado via morph/Section Rendering,
 * e scripts inseridos por morph não executam. Registrado aqui, o custom element
 * faz upgrade automático de qualquer <cart-tabs> que apareça (inclusive morphado).
 */
(function () {
  if (!window.customElements || customElements.get('cart-tabs')) return;
  customElements.define('cart-tabs', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.querySelectorAll('[data-cart-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-cart-tab');
          var wasActive = tab.classList.contains('is-active');
          self.querySelectorAll('[data-cart-tab]').forEach(function (t) { t.classList.remove('is-active'); });
          self.querySelectorAll('[data-cart-panel]').forEach(function (p) { p.hidden = true; });
          if (!wasActive) {
            tab.classList.add('is-active');
            var panel = self.querySelector('[data-cart-panel="' + key + '"]');
            if (panel) panel.hidden = false;
          }
        });
      });
    }
  });
})();
